import newCurriculumModalEn from "./locales/en.json";

export const NEW_CURRICULUM_MODAL_NS = "newCurriculumModal" as const;

export const NewCurriculumModalTranslations = {
  en: {
    [NEW_CURRICULUM_MODAL_NS]: {
      ...newCurriculumModalEn,
    },
  },
};
